import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import VenueList from './VenueList';
import VenueForm from './VenueForm';
import VenueDashboard from './VenueDashboard';
import VenueScopedLayout from '../../../components/layout/VenueScopedLayout';
// Locations
import VenueLocationList from './locations/VenueLocationList';
import VenueLocationForm from './locations/VenueLocationForm';
// Wine Lists
import WineListList from './wine-lists/WineListList';
import WineListForm from './wine-lists/WineListForm';
import WineListDetail from './wine-lists/WineListDetail';
import WineListItemForm from './wine-lists/WineListItemForm';
import WineListImport from './wine-lists/WineListImport';
// Inventory
import InventoryDashboard from './inventory/InventoryDashboard';
import InventoryMovementFeed from './inventory/InventoryMovementFeed';
import InventoryValuation from './inventory/InventoryValuation';
import InventoryItemList from './inventory/InventoryItemList';
import InventoryItemDetail from './inventory/InventoryItemDetail';
import InventoryItemForm from './inventory/InventoryItemForm';
import ManualAdjustmentForm from './inventory/ManualAdjustmentForm';
import InventoryAlerts from './inventory/InventoryAlerts';
// Purchasing
import PurchaseOrderList from './purchasing/PurchaseOrderList';
import PurchaseOrderForm from './purchasing/PurchaseOrderForm';
import PurchaseOrderDetail from './purchasing/PurchaseOrderDetail';
import ReceivingScreen from './purchasing/ReceivingScreen';
import InvoiceList from './purchasing/InvoiceList';
// Stock Counts
import StockCountList from './stock-counts/StockCountList';
import StockCountForm from './stock-counts/StockCountForm';
import StockCountEntry from './stock-counts/StockCountEntry';
import StockCountReview from './stock-counts/StockCountReview';
// Transfers
import TransferList from './transfers/TransferList';
import TransferForm from './transfers/TransferForm';
import TransferEntry from './transfers/TransferEntry';
import TransferReview from './transfers/TransferReview';
// POS Inventory
import PosGovernanceList from './pos-inventory/PosGovernanceList';
// Ownership
import OwnershipAccountList from './ownership/OwnershipAccountList';
import OwnershipAccountForm from './ownership/OwnershipAccountForm';
import OwnershipReports from './ownership/OwnershipReports';

const VenueRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Global venue management */}
      <Route path="/" element={<VenueList />} />
      <Route path="/create" element={<VenueForm />} />
      <Route path="/edit/:venueId" element={<VenueForm />} />

      {/* Venue-scoped workspace — all nested under VenueScopedLayout */}
      <Route path="/:venueId" element={<VenueScopedLayout />}>
        <Route index element={<VenueDashboard />} />

        {/* Locations */}
        <Route path="locations" element={<VenueLocationList />} />
        <Route path="locations/create" element={<VenueLocationForm />} />
        <Route path="locations/edit/:locationId" element={<VenueLocationForm />} />

        {/* Wine Lists */}
        <Route path="wine-lists" element={<WineListList />} />
        <Route path="wine-lists/create" element={<WineListForm />} />
        <Route path="wine-lists/edit/:wineListId" element={<WineListForm />} />
        <Route path="wine-lists/:wineListId" element={<WineListDetail />} />
        <Route path="wine-lists/:wineListId/add" element={<WineListItemForm />} />
        <Route path="wine-lists/:wineListId/edit/:itemId" element={<WineListItemForm />} />
        <Route path="wine-lists/:wineListId/import" element={<WineListImport />} />

        {/* Inventory */}
        <Route path="inventory" element={<InventoryItemList />} />
        <Route path="inventory/dashboard" element={<InventoryDashboard />} />
        <Route path="inventory/movements" element={<InventoryMovementFeed />} />
        <Route path="inventory/valuation" element={<InventoryValuation />} />
        <Route path="inventory/create" element={<InventoryItemForm />} />
        <Route path="inventory/adjust" element={<ManualAdjustmentForm />} />
        <Route path="inventory/alerts" element={<InventoryAlerts />} />
        <Route path="inventory/:itemId" element={<InventoryItemDetail />} />
        <Route path="inventory/:itemId/edit" element={<InventoryItemForm />} />

        {/* Purchasing */}
        <Route path="purchasing" element={<PurchaseOrderList />} />
        <Route path="purchasing/invoices" element={<InvoiceList />} />
        <Route path="purchasing/create" element={<PurchaseOrderForm />} />
        <Route path="purchasing/:poId" element={<PurchaseOrderDetail />} />
        <Route path="purchasing/:poId/edit" element={<PurchaseOrderForm />} />
        <Route path="purchasing/:poId/receive" element={<ReceivingScreen />} />

        {/* Stock Counts */}
        <Route path="stock-counts" element={<StockCountList />} />
        <Route path="stock-counts/create" element={<StockCountForm />} />
        <Route path="stock-counts/:countId" element={<StockCountEntry />} />
        <Route path="stock-counts/:countId/review" element={<StockCountReview />} />

        {/* Transfers */}
        <Route path="transfers" element={<TransferList />} />
        <Route path="transfers/create" element={<TransferForm />} />
        <Route path="transfers/:transferId" element={<TransferEntry />} />
        <Route path="transfers/:transferId/review" element={<TransferReview />} />

        {/* POS Inventory */}
        <Route path="pos-inventory/governance" element={<PosGovernanceList />} />

        {/* Ownership */}
        <Route path="ownership-accounts" element={<OwnershipAccountList />} />
        <Route path="ownership-accounts/create" element={<OwnershipAccountForm />} />
        <Route path="ownership-accounts/edit/:accountId" element={<OwnershipAccountForm />} />
        <Route path="ownership-reports" element={<OwnershipReports />} />
      </Route>

      <Route path="*" element={<Navigate to="/admin/venues" replace />} />
    </Routes>
  );
};

export default VenueRoutes;
